module.exports = __webpack_public_path__ + "static/media/github_pattern.25e1514c.svg";